const MINUTE = 20;
export const TIME = 1000 * 60 * MINUTE;
